export default "__VITE_ASSET__Djs_bEcr__"